var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSup3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 802.223,
    height: 377.614,
    viewBox: "0 0 802.223 377.614",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ffb8b8;}.b{fill:#e5e5e5;}.c{fill:#fff;}.d{fill:#3f3d56;}.e{fill:#44bba4;}.f{fill:#e6e6e6;}.g{fill:#f2f2f2;}.h{fill:#ccc;}.i{fill:#f1f1f1;}.j{fill:#cbcbcb;}.k{fill:#2f2e41;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-64.796 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M747.545,392.573a11,11,0,0,1,14.891,6.915,10.6,10.6,0,0,1,.32,1.435l43.938,21.788,10.168-6.739,12.652,14.565-15.526,12.61a11.148,11.148,0,0,1-13.3.513l-44.58-30.828a10.518,10.518,0,0,1-1.015.37,11,11,0,0,1-14.01-8.561,10.707,10.707,0,0,1-.163-1.34,11.036,11.036,0,0,1,6.626-10.729Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M202.8,460.226a6.5,6.5,0,0,0,6.5,6.5H219.9l1.891,3.427V622.226a6.5,6.5,0,0,0,13,0v-155.5H590.7l.1,155.5a6.5,6.5,0,0,0,13,0v-155.5h11.5a6.5,6.5,0,0,0,0-13h-406a6.5,6.5,0,0,0-6.5,6.5Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M351.7,552.127v-24a4,4,0,0,0-4-4h-91a4,4,0,0,0-4,4v24Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 99,
    height: 31,
    transform: "translate(114.697 299.934)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M252.7,601.127v24a4,4,0,0,0,4,4h91a4,4,0,0,0,4-4v-24Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(161.697 274.934)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(161.697 314.934)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(161.536 354.087)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M234,445.26v7.94a1.649,1.649,0,0,0,1.74,1.53h31.42a1.941,1.941,0,0,0,.86-.2l7.93-3.97a1.445,1.445,0,0,0,0-2.66l-7.93-3.97a1.941,1.941,0,0,0-.86-.2H235.74a1.649,1.649,0,0,0-1.74,1.53Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M235.74,443.73H242v11h-6.26A1.649,1.649,0,0,1,234,453.2v-7.94a1.649,1.649,0,0,1,1.74-1.53Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M989.444,541.948a24.745,24.745,0,0,1-23.9-4.209c-8.369-7.025-10.993-18.6-13.128-29.314l-6.315-31.7,13.221,9.1c9.508,6.547,19.23,13.3,25.814,22.786s9.457,22.428,4.167,32.689",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M988.314,580.322c1.338-9.747,2.714-19.62,1.776-29.472-.834-8.75-3.5-17.3-8.937-24.3a40.426,40.426,0,0,0-10.372-9.4c-1.037-.655-1.992.989-.959,1.641a38.433,38.433,0,0,1,15.2,18.343c3.31,8.418,3.841,17.6,3.271,26.538-.345,5.408-1.076,10.781-1.813,16.146a.985.985,0,0,0,.664,1.169.956.956,0,0,0,1.169-.664Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M975.425,563.074a18.215,18.215,0,0,1-15.871,8.192c-8.034-.381-14.732-5.989-20.762-11.312l-17.834-15.746,11.8-.565c8.488-.406,17.2-.785,25.28,1.832s15.541,8.917,17.019,17.286",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M992.1,585.926c-6.441-11.4-13.912-24.063-27.261-28.111a30.421,30.421,0,0,0-11.466-1.184c-1.217.1-.913,1.982.3,1.877a28.261,28.261,0,0,1,18.3,4.841c5.159,3.512,9.177,8.394,12.577,13.572,2.083,3.172,3.948,6.477,5.814,9.779.6,1.055,2.339.294,1.736-.774Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1002.42,597.922a13.793,13.793,0,0,0-8.452-11.552v-6.589H982.917v6.8a13.786,13.786,0,0,0-7.992,11.345l-2.6,30.206h32.692Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M377.282,452.651l3.283-1.382,2.252-16.456H412.8l2.441,16.389,2.937,1.468a.7.7,0,0,1-.312,1.321H377.552a.7.7,0,0,1-.27-1.34Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M321.079,434.084V413.311H474.212v20.772A2.918,2.918,0,0,1,471.3,437H323.991a2.919,2.919,0,0,1-2.912-2.918Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M320.925,334.248a3.522,3.522,0,0,1,3.518-3.518H470.828a3.522,3.522,0,0,1,3.518,3.518v88.881H320.925Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M327.376,413.966V339.893a2.715,2.715,0,0,1,2.712-2.712H465.183a2.715,2.715,0,0,1,2.712,2.712v74.073a2.715,2.715,0,0,1-2.712,2.712H330.089A2.715,2.715,0,0,1,327.376,413.966Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M612.1,261.193H747.491v161.66H612.1Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M612.1,261.193H747.491v161.66H612.1Zm133,2.388H614.488V420.464H745.1Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 94.709,
    height: 3.66,
    transform: "translate(494.441 78.285)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M578.965,56.406H580V19.379H543.614v1.033h35.351Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M506.2,59.8h36.383V58.771H507.231V22.777H506.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 94.709,
    height: 3.66,
    transform: "translate(494.441 87.827)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 94.709,
    height: 3.66,
    transform: "translate(494.441 97.369)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 94.709,
    height: 3.66,
    transform: "translate(494.441 114.164)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 94.709,
    height: 3.66,
    transform: "translate(494.441 123.707)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 94.709,
    height: 3.66,
    transform: "translate(494.441 133.249)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M672.606,290.629l.955-1.169-1.439-1.638-1.282.8a7.149,7.149,0,0,0-2.5-1.26l-.166-1.643L666,285.575l-.366,1.563a7.151,7.151,0,0,0-2.9.967l-1.081-.883-1.638,1.438.736,1.185a7.149,7.149,0,0,0-1.332,2.748l-1.6.161-.141,2.175,1.608.376a7.147,7.147,0,0,0,.937,2.656l-.883,1.081,1.438,1.638,1.185-.736a7.15,7.15,0,0,0,2.578,1.29l.172,1.706,2.175.141.387-1.654a7.151,7.151,0,0,0,2.787-.947l1.169.955L672.879,300l-.8-1.282a7.153,7.153,0,0,0,1.3-2.642l1.69-.17.141-2.175-1.669-.391a7.151,7.151,0,0,0-.938-2.707Zm-2.279,8.031a5.813,5.813,0,1,1,.531-8.2,5.813,5.813,0,0,1-.531,8.2Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M685.657,306.445l1.317-.736-.737-2.052-1.485.269a7.149,7.149,0,0,0-1.861-2.089l.449-1.589-1.971-.93-.914,1.319a7.152,7.152,0,0,0-3.05-.165l-.681-1.218-2.052.736.249,1.373a7.15,7.15,0,0,0-2.249,2.067l-1.545-.437-.93,1.971,1.357.94a7.146,7.146,0,0,0-.1,2.814l-1.218.681.736,2.052,1.373-.249a7.15,7.15,0,0,0,1.924,2.147L673.8,315l1.971.93.968-1.4a7.151,7.151,0,0,0,2.94.143l.736,1.317,2.052-.736-.269-1.485a7.152,7.152,0,0,0,2.179-1.98l1.635.462.93-1.971-1.409-.976a7.152,7.152,0,0,0,.123-2.861Zm-5.07,6.633a5.813,5.813,0,1,1,3.507-7.436,5.813,5.813,0,0,1-3.507,7.436Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M701.781,297.034l.907-1.206-1.5-1.579-1.249.847a7.15,7.15,0,0,0-2.546-1.159l-.231-1.635-2.179-.054-.3,1.576a7.152,7.152,0,0,0-2.856,1.082l-1.115-.839-1.579,1.5.783,1.155a7.149,7.149,0,0,0-1.221,2.8l-1.589.225-.054,2.179,1.621.312a7.149,7.149,0,0,0,1.042,2.616l-.839,1.115,1.5,1.579,1.155-.783a7.151,7.151,0,0,0,2.628,1.186l.24,1.7,2.179.054.321-1.668a7.151,7.151,0,0,0,2.747-1.058l1.206.907,1.579-1.5-.846-1.249a7.152,7.152,0,0,0,1.192-2.692l1.682-.238.054-2.179-1.684-.323a7.151,7.151,0,0,0-1.045-2.667Zm-1.956,8.116a5.813,5.813,0,1,1,.2-8.219,5.813,5.813,0,0,1-.2,8.219Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M415.317,383.375l3.879-.308.482-5.6-3.769-.966a18.436,18.436,0,0,0-2.113-6.9l2.763-3.24-3.619-4.3-3.562,2.108a18.442,18.442,0,0,0-6.97-3.668l-.285-3.587-5.6-.482-.893,3.485a18.436,18.436,0,0,0-7.494,2.424l-3.15-2.686-4.3,3.619,2.169,3.664a18.431,18.431,0,0,0-3.272,6.484l-3.587.285-.482,5.6L379,380.2a18.439,18.439,0,0,0,2.2,7.1l-2.868,3.365,3.619,4.3,3.77-2.232a18.441,18.441,0,0,0,6.738,3.5l.309,3.879,5.6.482.967-3.77a18.445,18.445,0,0,0,7.236-2.3l3.334,2.843,4.3-3.619-2.252-3.8A18.441,18.441,0,0,0,415.317,383.375ZM396.3,393.464a14.992,14.992,0,1,1,16.221-13.651A14.992,14.992,0,0,1,396.3,393.464Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M839.06,526.722H791.05c0,1.38-49.48,2.5-49.48,2.5a12.856,12.856,0,0,0-2.11,2,12.41,12.41,0,0,0-2.9,8v2a12.5,12.5,0,0,0,12.5,12.5h90a12.511,12.511,0,0,0,12.5-12.5v-2A12.517,12.517,0,0,0,839.06,526.722Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 13,
    height: 84,
    transform: "translate(648.836 292.032)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M749.836,636.768c0,1.4,19.7.543,44,.543s44,.861,44-.543-19.7-12.543-44-12.543S749.836,635.364,749.836,636.768Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M623.571,365.73H611.312l-5.833-31.8h18.094Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M764.7,638.807H725.167v-.5a15.386,15.386,0,0,1,15.386-15.386H764.7Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M743.235,607.205,718.794,552.4a20.086,20.086,0,0,1,8.819-25.784l53.013-28.428,24.191-2.058,22.315-2.028.161.272c.206.348,5,8.635,1.76,17.722-2.46,6.893-8.859,12.276-19.019,16-23.714,8.7-51.109,16.127-61.786,18.918a3.451,3.451,0,0,0-2.211,1.76,3.5,3.5,0,0,0-.2,2.8l22.706,51.015a4.5,4.5,0,0,1-3.809,6.029l-16.967,1.235q-.216.021-.43.021A4.5,4.5,0,0,1,743.235,607.205Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M631.571,365.73H619.312l-5.833-31.8h18.094Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M772.7,638.807H733.167v-.5a15.386,15.386,0,0,1,15.386-15.386H772.7Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M752.235,610.205,727.794,555.4a20.086,20.086,0,0,1,8.819-25.784l53.013-28.428,24.191-2.058,17.478-1.516,0-.24c.206.348,5,8.635,1.76,17.722-2.46,6.893-3.859,12.276-14.019,16-23.714,8.7-51.109,16.127-61.786,18.918a3.451,3.451,0,0,0-2.211,1.76,3.5,3.5,0,0,0-.2,2.8l22.706,51.015a4.5,4.5,0,0,1-3.809,6.029l-16.967,1.235q-.216.021-.43.021a4.5,4.5,0,0,1-4.106-2.667Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M798.295,498.612c-1.172-.829-18,8-21,1,14-35,4.353-50.114,12.928-70.185a24.992,24.992,0,0,1,16.567-14.18l22.249-1.123.115.056a26.005,26.005,0,0,1,14.219,27.588c-.079,21.843-13.148,38.5-8.579,54.346a5.122,5.122,0,0,1-.484,3.983,4.884,4.884,0,0,1-3.116,2.309l-29.378-3.919a4.964,4.964,0,0,1-4.017-.777Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 24.561,
    cy: 24.561,
    r: 24.561,
    transform: "translate(659.054 95.499)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M775.224,464.483,732.55,430.817a10.514,10.514,0,0,1-1.036.306,11.027,11.027,0,0,1-8.818-1.691A11,11,0,1,1,739.7,417.9a10.574,10.574,0,0,1,.229,1.452l42.481,24.507,10.572-6.086L804.7,453.1l-16.414,11.7a10.942,10.942,0,0,1-13.059-.318Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M809.9,457.877,785.555,441.32,797,425.113a11.168,11.168,0,0,1,13.929-3.64h0a11.168,11.168,0,0,1,5.894,13.283Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M829.438,403.8c-1.3.571-3.977-9.827-2.78-11.907,1.78-3.093,1.675-3.071,2.857-5.117s1.446-4.847-.084-6.648-5.072-1.562-5.77.7c.449-4.288-3.792-7.735-7.993-8.7s-8.632-.367-12.857-1.229c-4.9-1-10-5.11-8.047-10.5a7.592,7.592,0,0,1,1.481-2.434c2.26-2.541,5.421-3.626,8.512-4.675,6.43-2.182,13.036-4.392,19.822-4.151a28.8,28.8,0,0,1,25.446,18.609,26.157,26.157,0,0,1,1.083,4.025c2.329,12.524-4.944,24.878-16.756,29.647Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M480.619,539.133v2a12.511,12.511,0,0,0,12.5,12.5h90a12.5,12.5,0,0,0,12.5-12.5v-2a12.41,12.41,0,0,0-2.9-8,12.862,12.862,0,0,0-2.11-2s-49.48-1.12-49.48-2.5h-48.01A12.517,12.517,0,0,0,480.619,539.133Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 13,
    height: 84,
    transform: "translate(394.342 291.943)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M538.343,624.136c-24.3,0-44,11.139-44,12.543s19.7.543,44,.543,44,.861,44-.543S562.643,624.136,538.343,624.136Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M443.761,332.185h18.094l-5.833,31.8H443.763Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M578.636,621.172h24.145a15.386,15.386,0,0,1,15.386,15.386v.5H578.637Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M595.993,608.124q-.214,0-.43-.021L578.6,606.868a4.5,4.5,0,0,1-3.809-6.029l22.707-51.015a3.5,3.5,0,0,0-.2-2.8,3.451,3.451,0,0,0-2.211-1.76c-10.677-2.791-38.072-10.223-61.786-18.918-10.16-3.726-16.559-9.109-19.019-16-3.243-9.087,1.555-17.374,1.76-17.722l.161-.272,22.315,2.028,24.191,2.058,53.013,28.428a20.086,20.086,0,0,1,8.819,25.784L600.1,605.457A4.5,4.5,0,0,1,595.993,608.124Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M437.761,332.185h18.094l-5.833,31.8H437.763Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M572.636,621.172h24.145a15.386,15.386,0,0,1,15.386,15.386v.5H572.637Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M588.993,611.124q-.214,0-.43-.021L571.6,609.868a4.5,4.5,0,0,1-3.809-6.029l22.706-51.015a3.5,3.5,0,0,0-.2-2.8,3.451,3.451,0,0,0-2.211-1.76c-10.677-2.791-38.072-10.223-61.786-18.918-10.16-3.726-16.559-9.109-19.019-16-3.243-9.087,1.555-17.374,1.76-17.722l.161-.272,22.315,2.028,24.191,2.058,53.013,28.428a20.086,20.086,0,0,1,8.819,25.784L593.1,608.457a4.5,4.5,0,0,1-4.107,2.667Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M503.5,417.08a11.168,11.168,0,0,1,14.262-2.784h0a11.168,11.168,0,0,1,5,13.5l-6.72,18.667L488.524,436Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M558.534,509.963a4.964,4.964,0,0,1-4.017.777l-42.378-10.081a4.884,4.884,0,0,1-3.116-2.309,5.122,5.122,0,0,1-.484-3.983c4.57-15.843-1.422-35.483-8.579-54.346a26.005,26.005,0,0,1,14.219-27.588l.115-.056,22.25,1.123a24.992,24.992,0,0,1,16.567,14.18c8.576,20.071,11.031,45.825,7.506,78.735a5,5,0,0,1-2.083,3.549Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 24.561,
    cy: 24.561,
    r: 24.561,
    transform: "translate(355.542 138.619) rotate(-80.783)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M555.052,463.054l-16.414-11.7,11.711-15.332,10.572,6.086L603.4,417.6a10.583,10.583,0,0,1,.229-1.452,11,11,0,1,1,8.191,13.226,10.519,10.519,0,0,1-1.036-.306l-42.674,33.666A10.942,10.942,0,0,1,555.052,463.054Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M526.513,433.007a11.168,11.168,0,0,1,5.894-13.283h0a11.168,11.168,0,0,1,13.929,3.64l11.443,16.207L533.43,456.129Z",
    transform: "translate(-138 -261.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M530.785,375.951a4.437,4.437,0,0,1-.594,5.186c-3.489,3.946-4.419,10.054-3.162,15.315,1.509,6.313,5.516,11.693,9.472,16.839s8.051,10.431,9.789,16.685c4.114,14.805-6.938,30.594-21.141,36.46s-30.378,4.008-45.332.474c-11.287-2.667-22.935-6.591-30.654-15.248s-9.767-23.311-1.564-31.51c6.43-6.427,16.443-6.945,25.391-8.555s19.083-6.354,20.281-15.367c1.191-8.955-7.2-16.355-8.779-25.25-1.965-11.06,7.655-21.6,18.541-24.373s22.367.307,32.911,4.181c8.111,2.979,16.593,6.866,19.68,15.695,1.717,4.909.383,10.5-3.851,13.525-6.447,4.6-14.736.16-21.049-4.161Z",
    transform: "translate(-138 -261.193)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSup3);
export default __webpack_public_path__ + "static/media/sup3.387ac1a87b4ea51a3182c85dc2aaa9a2.svg";
export { ForwardRef as ReactComponent };